// extracted by mini-css-extract-plugin
module.exports = {"taskListMain":"TaskList_taskListMain__ygc9J","header":"TaskList_header__5bWja"};